import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { OrganizationsService } from '../../services';
import setOrgUserRole from '../../reducers/organizations/actions/setOrgUserRole';

import {
  types as actions
} from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_ORG_USER_ROLE),
    switchMap(action =>
      OrganizationsService.getOrgUserRole(store, action.orgId).pipe(
          map(data => {
            return setOrgUserRole(data)
          }),
          catchError(retryAuthentication(action$, 'epics/organizations/getOrgUserRole'))
      ))
  )
}



// WEBPACK FOOTER //
// ./src/epics/organizations/getOrgUserRole.js